import { useEffect, useRef, useState } from 'react';
import PriceInfoBlock from './PriceInfoBlock';
import ApartmentQueryButton from './ApartmentQueryButton';
import styles from '../../../styles/aprt.module.scss';

function StickyPriceSection({ apartmentData }) {
	const [isStuck, setIsStuck] = useState(false);
	const sentinelRef = useRef(null);
	const sectionRef = useRef(null);

	useEffect(() => {
		const sentinel = sentinelRef.current;
		if (!sentinel) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				// When sentinel is NOT visible, the sticky section is stuck
				setIsStuck(!entry.isIntersecting);
			},
			{
				threshold: [1], // Trigger when fully visible/invisible
				rootMargin: '-1px 0px 0px 0px', // Small offset to detect sticky state
			}
		);

		observer.observe(sentinel);

		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<>
			{/* Sentinel element - when this disappears, sticky is active */}
			<div 
				ref={sentinelRef} 
				style={{ 
					height: '1px', 
					width: '100%', 
					position: 'absolute',
					top: '-1px',
					pointerEvents: 'none',
				}} 
			/>
			<div 
				ref={sectionRef}
				// className={`${styles.sticky_price_section} ${isStuck ? styles.sticky_price_section_stuck : ''}`}
				className={styles.sticky_price_section}
			>
				<PriceInfoBlock isStuck={isStuck} />
				{/* <ApartmentQueryButton apartmentData={apartmentData} /> */}
			</div>
		</>
	);
}

export default StickyPriceSection;
